/**
 * Import Dependency
 */
import { handleActions } from 'redux-actions'
import update from 'immutability-helper'

/**
 * Declare Variable
 */
const defaultSetStepState = {}
const defaultIsSearchMode = false
/**
 * Export
 */

export const setStep = handleActions({
  UPDATE_SET_STEP: (state, action) => {
    return update(state, {
      current: {
        $set: action.payload,
      },
    })
  },
}, defaultSetStepState)

export const isSearchMode = handleActions({
  UPDATE_SEARCHMDOE_DISPLAY: (state, action) => {
    return action.payload.isSearchMode
  },
}, defaultIsSearchMode)

export default {
  setStep,
  isSearchMode,
}



// WEBPACK FOOTER //
// ./src/reducers/components/categorydetaillist.js